<template>
    <div>
        <div class="tournament__participation__item">
            <div class="tournament__participation__item__title float-content">

                <p class="item-title fl"
                   :style="{backgroundImage: `url('${require('@/image/icon/icn-filter-07.svg')}')`}">단체</p>
                <div class="add__player fr">
                    <div class="add__player__content">
                        <p class="player__count">{{playerList.length-1}}명</p>
                        <div class="add__player__btn" @click="addPlayer"><p>참가자 추가</p></div>
                    </div>

                </div>
            </div>

            <!--본인일경우-->
            <div class="form-control-select-wrap">

                <div class="form-control-select">
                    <p class="input-title">단체명</p>
                    <input class="form-control-select" placeholder="입력해주세요" v-model="teamName">
                </div>
            </div>


        </div>


        <TeamOpenForm v-model="playerList[playerIndex]" :index="playerIndex"
                      @delete="playerDeleteFunc(playerIndex)" v-for="(player, playerIndex) in playerList"
                      v-if="playerIndex>0" :key="`player${playerIndex}`"></TeamOpenForm>
    </div>
</template>
<script>
    import TeamOpenForm from "./TeamOpenForm";
    import participantMixin from "../../../mixins/participantMixin";

    export default {
        components: {TeamOpenForm},
        mixins: [participantMixin],
        data() {
            return {
                playerList: [{}, {}],
                teamName: null
            }
        },
        methods: {
            addPlayer() {
                this.playerList.push({})
            },
            playerDeleteFunc(playerIndex) {
                this.playerList.splice(playerIndex, 1)
            }
        },
        watch: {
            teamName: function (newVal) {
                this.playerList[0] = {

                    "playerName": newVal,
                    "mobile": "",
                    "gender": null,
                    "dateOfBirth": "",
                    "teamName": "",
                    "type": "T"
                }
            }
        }
    }
</script>
